import { Button } from '@/shared/ui/button';

export default function CategoryLink({
  tab,
  active,
  onClick,
}: {
  tab: { slug: string; title: string };
  active: boolean;
  onClick: () => void;
}) {
  return (
    <Button
      rounded="full"
      size="sm"
      fontWeight={500}
      {...(active
        ? {
            bg: 'primary',
            color: 'primary.text',
            _hover: {
              bg: 'primary.hover',
            },
          }
        : {
            variant: 'subtle',
          })}
      onClick={onClick}
    >
      {tab?.title}
    </Button>
  );
}

